import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
import voiceEvacuation from '../../../../../src/assets/images/voice-evacuation.png';
import ASD from '../../../../../src/assets/images/ASD.png';
import aerosol from '../../../../../src/assets/images/aerosol.png';
import FireAlarm from '../../../../../src/assets/images/fire-alarm.png';
import cleanagent from '../../../../../src/assets/images/clean-agent.png';
import fireextinguisher from '../../../../../src/assets/images/fire-extinguisher.png';
import firehosecabinet from '../../../../../src/assets/images/fire-hose-cabinet.png';
import firewatertank from '../../../../../src/assets/images/fire-water-tank.png';
import foamsystem from '../../../../../src/assets/images/foam-system.png';
import kitchenhoodfs from '../../../../../src/assets/images/kitchen-hood.png';
import standpipe from '../../../../../src/assets/images/standpipe.png';
import firepump from '../../../../../src/assets/images/firepump.png';
import firehydrant from '../../../../../src/assets/images/fire-hydrant.png';
import fireprotect from '../../../../../src/assets/images/fireprotect.png';
import defaulr from '../../../../../src/assets/images/defaulr.jpeg';
import FormLayout from "../FormLayout";
import { useToast } from "../../../../Components/Others/ToastServices";
import UseGetDataSearch from "../../../../Components/Hooks/useFetchDataBySearch";
import UseCatSubCatDropDown from "../../../../Components/Hooks/useCategoryDropDown";
import Pagination from "../../../../Components/Utils/Pagenation";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import { CancelButton, SubmitButton } from "../../../../Components/Utils/Buttons";
import ImportForms from "./ImportForms";
import MultiEditForms from "./MultiEditForms";
import ModalContainer from "../../../../Components/Others/ModalContainer";
import CloseIcon from "../../../../Components/Icons/Close";
import { NuDate } from "../../../../Components/Utils/Input";
import axiosInstance from "../../../../Services/axiosCommon";
import useFetchMDIndex from "../../../../Components/Hooks/useFetchMDIndex";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";

const formImages = {
  "Fire Protection System - Summary": fireprotect,
  "Fire Pump": firepump,
  "Fire Water Tanks": firewatertank,
  "Fire / Foam Hose Cabinet": firehosecabinet,
  "Fire / Foam Hose Cabinet Details": firehosecabinet,
  "Fire Extinguisher": fireextinguisher,
  "Fire Extinguisher Details": fireextinguisher,
  "Clean Agent Fire Suppression System": cleanagent,
  "Fire Alarm System": FireAlarm,
  "Aspirating Smoke Detection System": ASD,
  "Asd System": ASD,
  "Voice Evacuation System /Pava": voiceEvacuation,
  "Stand Pipe Hose System": standpipe,
  "Foam Fire Suppression System": foamsystem,
  "Fire Hydrant": firehydrant,
  "Kitchen Hood Fire Suppression Sys.": kitchenhoodfs,
  "Aerosol Fire Suppression System": aerosol,
};

// Using a simple document icon as default
const defaultImage = defaulr;

function FormsIndex() {
   const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const toast = useToast();
  const location = useLocation();
  const currentPage = location.state?.currentPage;
  const searchQuery = location.state?.searchQuery;
  const [page, setPage] = useState(currentPage || 1);
  const [pageCount, setPageCount] = useState(
    localStorage.getItem("perPageView") || 20
  );

   const { value: FormType} = useFetchMataData(
         `/dropdown/dropdown-details/`,
         "Form_Types"
       );

const [formList, setFormList] = useState([]);
const [loading, setLoading] = useState(false);


  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search: searchQuery || "",
    category: "",
    
  });
  
  const { data, totalCount, getData, dataLoading,total } = UseGetDataSearch(
    "/form/all-forms",
   params
  );

  const handleTabClick = (formTypeValue) => {
  setActiveTab(formTypeValue);
  setParams((prev) => ({
    ...prev,
    category: formTypeValue,
    page: 1 
  }));
};


useEffect(() => {
  const fetchForms = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/form/all-forms", {
        params,
      });
      setFormList(response.data?.data || []);
    } catch (err) {
      console.error("Failed to fetch forms", err);
    } finally {
      setLoading(false);
    }
  };

  if (params.category) {
    fetchForms();
  }
}, [params]);


  
 
  useEffect(() => {
    setParams({ ...params, page: page, per_page: pageCount });
  }, [page, pageCount]);





  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [listofNumbers, setListofNumbers] = useState([]);
  const [fullList, setFullList] = useState([]);

  const handleMultiDelete = (data) => {
    axiosInstance
      .delete(`items/multi-delete`, {
        headers: {
          "Content-Type": "application/json",
        },
        data: { ids: data },
      })
      .then((res) => {
        if (res.data?.status === true) {
          if (res?.data?.not_deleted_ids.length <= 0) {
            toast.open({
              type: "success",
              message: "Success",
              description: res.data?.msg || "Deleted Successfully.",
            });
            getData();
            setShowDelete(false);
          } else {
            toast.open({
              type: "warning",
              message: "Success",
              description:
                `${res.data?.msg} \n Some Products has dependenies` ||
                "Deleted Successfully.",
            });
            getData();
            setShowDelete(false);
          }
        } else if (res.data?.status === false && res.data?.error) {
          toast.open({
            type: "error",
            message: "Error",
            description: res.data.error || "Delete UnSuccessfull",
          });
        } else {
          toast.open({
            type: "warning",
            message: "Warning",
            description: res.data?.msg || "Warning.",
          });
        }
      })
      .catch((err) => {
        console.error(err);
        toast.open({
          type: "error",
          message: "Error",
          description: "Network Error.",
        });
      });
  };

  console.log("Data", data);
  
   const [valueOfSearch,setValuesofSearch] = useState("")
     function searchFunction(e) {
   
       
       setValuesofSearch(e?.target?.value)
       setParams({ ...params, search: e?.target?.value, page:1 });
       setPage(1)
     }

     
     
const [activeTab, setActiveTab] = useState("");

useEffect(() => {
  if (FormType?.length > 0 && !activeTab) {
    const defaultType = FormType[0].value;
    setActiveTab(defaultType);
    setParams((prev) => ({ ...prev, category: defaultType }));
  }
}, [FormType]);


  return (
    <>
    <FormLayout
            searchFun={searchFunction}
            searchValue={valueOfSearch}
                  total={totalCount}

    >
    <div className="w-full h-full  mt-0.5 ">
     
      <div className=" w-full h-[calc(100vh-180px)] bg-white  rounded-md overflow-hidden px-4 py-2">
        {/* <p className=" text-xs 2xl:text-sm font-medium">Total Form : {data.length||0}</p> */}
        <div className=" w-full h-[calc(100vh-235px)] ">
         <div className="flex flex-wrap">
  {FormType?.map((form) => (
    <button
      key={form.value}
      onClick={() => handleTabClick(form.value)}
      className={`mx-3 mb-2 pb-1 text-xs 2xl:text-sm font-medium ${
        activeTab === form.value
          ? "text-baseColor-primary underline underline-offset-4 decoration-2"
          : "text-gray-500"
      }`}
    >
      {form.label} 
    </button>
  ))}
</div>

        <div className="w-full max-h-[calc(100vh-235px)] grid grid-cols-2 md:grid-cols-5 lg:grid-cols-7 gap-4 overflow-y-auto py-4">
  {data &&
    data.map((item, i) => {
      return (
        <Link
          key={i}
          to={`/forms/insforms/view/${item?.id}`}
          state={{ data: item }}
          className="relative w-full h-auto bg-white text-[#111537] rounded-lg shadow-lg"
        >
          {/* Serial Number Top-Left */}
          <div className="h-[30px] w-full">
          <span className="absolute top-1 left-2 text-xs  text-gray-500 border border-pageborder rounded-md p-1 w-5 h-5 flex items-center justify-center">
            {i + 1}
          </span>
</div>
          <div className="w-full h-auto flex flex-col py-1 px-2 justify-between items-center">
            <img 
                      src={formImages[item.formName] || defaultImage} 
                      alt={item.formName}
                      className="w-16 h-16 object-contain"
                      onError={(e) => {
                        e.target.src = defaultImage;
                      }}
                    />
            <p className="line-clamp-3 text-xs text-center">
              {item?.formName || ""}
            </p>
          </div>
        </Link>
      );
    })}
</div>

        </div>
        <div className=" w-full h-[40px] pb-4 bg-white">
          <Pagination
            page={page}
            setPage={setPage}
            totalCount={totalCount}
            pageCount={pageCount}
            setPageCount={setPageCount}
          />
        </div>
      </div>
    
     
      <ModalContainer
        visiable={showDelete}
        title="Warning"
        content={`Are you sure, All selected datas will be removed from YPR List!`}
        handleClick={() => {
          handleMultiDelete(listofNumbers);
        }}
        closeModal={() => setShowDelete(false)}
      />

     
    </div>
    </FormLayout></>
  );
}

export default FormsIndex;
